import { AspectRatio, Image, ImageProps } from "@chakra-ui/react";
import { filestoreUrl } from "config";

type FancyBearImageProps = Omit<
  ImageProps,
  "src" | "fallbackSrc" | "opacity"
> & {
  tokenId: number;
  size?: "256" | "512" | "1024";
  isDisabled?: boolean;
};

const FancyBearImage = ({
  tokenId,
  size = "512",
  isDisabled = false,
}: FancyBearImageProps) => (
  <AspectRatio ratio={1} w="full">
    <Image
      src={`${filestoreUrl}/${size}/${tokenId}.png`}
      fallbackSrc={`${process.env.PUBLIC_URL}/bear-placeholder.png`}
      fit="cover"
      opacity={isDisabled ? 0.5 : 1}
      transition="opacity 0.2s"
    />
  </AspectRatio>
);

export default FancyBearImage;
